export const testAttributes = {
    INFO_BOX_CONTAINER: 'info_box_container',
    INFO_BOX_ICON: 'info_box_icon',
    INFO_BOX_CONTENT: 'info_box_content',
};

